import { combineDataProviders } from 'react-admin';

import { DashboardResources } from '@src/types';
import { usersDataProvider } from '@src/users';
import { userRolesDataProvider } from '@src/userRoles';
import { conditionsDataProvider } from '@src/conditions';
import { facetsDataProvider } from '@src/facets';
import { vitalElementsDataProvider } from '@src/vitalElements';
import {
  pricingRulesDataProvider,
  conditionDiscountsDataProvider,
  itemAdjustedPricesDataProvider,
} from '@src/resalePricing';
import { shopifySyncDataProvider } from '@src/shopifySync';
import { inventoryItemsDataProvider } from '@src/inventoryItems';
import { giftcardsDataProvider } from '@src/giftCards';
import { ordersDataProvider } from '@src/orders';
import { tradeinsDataProvider } from '@src/tradeins';
import { settingsDataProvider } from '@src/settings';
import { shopifyRedirectsDataProvider } from '@src/shopifyRedirects';
import { lookerDashboardsDataProvider } from '@src/lookerDashboards';

import {
  catalogItemsDataProvider,
  variantSkusDataProvider,
  pluginsDataProvider,
  repairsDataProvider,
} from './resources';
import { repairPricingDataProvider } from '@src/repairPricing';

export const dataProvider = combineDataProviders((resource: DashboardResources | string) => {
  switch (resource) {
    case DashboardResources.CatalogItems:
      return catalogItemsDataProvider;
    case DashboardResources.VariantSkus:
      return variantSkusDataProvider;
    case DashboardResources.RecyclePlugins:
      return pluginsDataProvider;
    case DashboardResources.RepairPlugins:
      return pluginsDataProvider;
    case DashboardResources.ResalePlugins:
      return pluginsDataProvider;
    case DashboardResources.TradeinPlugins:
      return pluginsDataProvider;
    case DashboardResources.Repairs:
      return repairsDataProvider;
    case DashboardResources.CatalogFieldsMappingUpload:
      throw new Error('CatalogFieldsMappingUpload does not use a data provider');
    case 'users':
      return usersDataProvider;
    case 'userRoles':
      return userRolesDataProvider;
    case 'conditions':
      return conditionsDataProvider;
    case 'facets':
      return facetsDataProvider;
    case 'vitalElements':
      return vitalElementsDataProvider;
    case DashboardResources.PricingRules:
      return pricingRulesDataProvider;
    case DashboardResources.ConditionDiscounts:
      return conditionDiscountsDataProvider;
    case DashboardResources.ItemAdjustedPrices:
      return itemAdjustedPricesDataProvider;
    case DashboardResources.RepairPricing:
      return repairPricingDataProvider;
    case 'settings':
      return settingsDataProvider;
    case DashboardResources.ShopifyRedirects:
      return shopifyRedirectsDataProvider;
    case DashboardResources.ShopifySync:
      return shopifySyncDataProvider;
    case DashboardResources.InventoryItems:
      return inventoryItemsDataProvider;
    case DashboardResources.LookerDashboards:
      return lookerDashboardsDataProvider;
    case 'giftcards':
      return giftcardsDataProvider;
    case 'orders':
      return ordersDataProvider;
    case 'tradeins':
      return tradeinsDataProvider;
    default:
      throw new Error(`Unknown resource: ${resource}`);
  }
});

export default dataProvider;
